export interface MangaItem {
  slug: string;
  title: string;
  author: string;
  cover: string;
  category: string;
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  description: string;
  tags: string[];
  updatedAt: string;
  chapters: MangaChapter[];
}

export interface MangaChapter {
  id: number;
  title: string;
  updatedAt: string;
}

const mangaList: MangaItem[] = [
  {
    slug: 'duru-nvwang-de-shenshi',
    title: '独步女王的绅士',
    author: '金素英',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20webtoon%20style%20manga%20cover%20featuring%20an%20elegant%20queen%20in%20a%20royal%20palace%20setting%2C%20soft%20warm%20lighting%2C%20romance%20fantasy%20genre%2C%20delicate%20linework%2C%20pastel%20color%20palette%2C%20clean%20simple%20cream%20background%2C%20digital%20illustration%20style&width=600&height=800&seq=manga-cover-01&orientation=portrait',
    category: '恋爱',
    status: '连载中',
    rating: 9.2,
    views: 1280000,
    description: '在王室阴谋中，一位现代女性穿越成为女王，她凭借智慧和魅力周旋于各方势力之间。当她遇到那位神秘而忠诚的绅士骑士，命运之轮开始转动……一场跨越时空的浪漫宫廷故事就此展开。',
    tags: ['穿越', '宫廷', '浪漫', '女性向'],
    updatedAt: '2026-08-05',
    chapters: [
      { id: 1, title: '第1话 - 穿越之始', updatedAt: '2026-07-01' },
      { id: 2, title: '第2话 - 王座之上', updatedAt: '2026-07-03' },
      { id: 3, title: '第3话 - 暗流涌动', updatedAt: '2026-07-05' },
      { id: 4, title: '第4话 - 骑士之誓', updatedAt: '2026-07-08' },
      { id: 5, title: '第5话 - 宫廷舞会', updatedAt: '2026-07-12' },
      { id: 6, title: '第6话 - 阴谋浮现', updatedAt: '2026-07-15' },
      { id: 7, title: '第7话 - 挺身而出', updatedAt: '2026-07-19' },
      { id: 8, title: '第8话 - 月光之下', updatedAt: '2026-07-22' },
      { id: 9, title: '第9话 - 危机四伏', updatedAt: '2026-07-26' },
      { id: 10, title: '第10话 - 真实身份', updatedAt: '2026-07-30' },
    ],
  },
  {
    slug: 'an-ying-lie-ren',
    title: '暗影猎人',
    author: '李俊昊',
    cover: 'https://readdy.ai/api/search-image?query=A%20dark%20action%20Korean%20webtoon%20cover%20featuring%20a%20mysterious%20hunter%20in%20black%20coat%20with%20glowing%20eyes%2C%20urban%20fantasy%20setting%2C%20dramatic%20lighting%2C%20cool%20dark%20tone%2C%20action%20genre%2C%20clean%20simple%20dark%20cream%20background%2C%20digital%20illustration%20with%20bold%20lines&width=600&height=800&seq=manga-cover-02&orientation=portrait',
    category: '热血',
    status: '连载中',
    rating: 9.5,
    views: 2560000,
    description: '在一个被暗影生物威胁的世界里，拥有特殊能力的猎人们守护着人类最后的防线。主角林寒在意外获得上古猎人之力后，踏上了对抗黑暗势力的征程。激烈的战斗场面与深刻的人物刻画，让这部作品成为热血漫画的经典之作。',
    tags: ['战斗', '超能力', '暗黑', '成长'],
    updatedAt: '2026-08-04',
    chapters: [
      { id: 1, title: '第1话 - 觉醒', updatedAt: '2026-06-15' },
      { id: 2, title: '第2话 - 第一场战斗', updatedAt: '2026-06-17' },
      { id: 3, title: '第3话 - 猎人工会', updatedAt: '2026-06-20' },
      { id: 4, title: '第4话 - 黑暗降临', updatedAt: '2026-06-23' },
      { id: 5, title: '第5话 - 伙伴集结', updatedAt: '2026-06-27' },
      { id: 6, title: '第6话 - 深渊之门', updatedAt: '2026-07-01' },
      { id: 7, title: '第7话 - 生死较量', updatedAt: '2026-07-05' },
      { id: 8, title: '第8话 - 觉醒之刻', updatedAt: '2026-07-10' },
      { id: 9, title: '第9话 - 极限突破', updatedAt: '2026-07-15' },
      { id: 10, title: '第10话 - 新的威胁', updatedAt: '2026-07-20' },
      { id: 11, title: '第11话 - 远古之力', updatedAt: '2026-07-25' },
      { id: 12, title: '第12话 - 最终决战', updatedAt: '2026-07-30' },
    ],
  },
  {
    slug: 'mofa-shaonv-de-qiyue',
    title: '魔法少女的契约',
    author: '朴智慧',
    cover: 'https://readdy.ai/api/search-image?query=A%20magical%20girl%20Korean%20webtoon%20cover%20with%20sparkling%20stars%20and%20pastel%20colors%2C%20young%20girl%20in%20magical%20transformation%20outfit%2C%20fantasy%20genre%2C%20whimsical%20and%20dreamy%20atmosphere%2C%20soft%20warm%20cream%20background%2C%20delicate%20magical%20effects%2C%20digital%20illustration&width=600&height=800&seq=manga-cover-03&orientation=portrait',
    category: '奇幻',
    status: '已完结',
    rating: 9.0,
    views: 1890000,
    description: '普通高中生林小雨在某天遇到了会说话的魔法生物，签订了魔法少女契约。从此她在学业与守护城市之间奔波，还要面对其他魔法少女的竞争与黑暗势力的威胁。温暖治愈又不乏激燃的魔法冒险故事。',
    tags: ['魔法', '校园', '治愈', '冒险'],
    updatedAt: '2026-07-28',
    chapters: [
      { id: 1, title: '第1话 - 相遇', updatedAt: '2026-05-01' },
      { id: 2, title: '第2话 - 契约', updatedAt: '2026-05-03' },
      { id: 3, title: '第3话 - 初次变身', updatedAt: '2026-05-06' },
      { id: 4, title: '第4话 - 第一个敌人', updatedAt: '2026-05-10' },
      { id: 5, title: '第5话 - 同伴', updatedAt: '2026-05-14' },
      { id: 6, title: '第6话 - 校园祭', updatedAt: '2026-05-18' },
      { id: 7, title: '第7话 - 黑暗来袭', updatedAt: '2026-05-22' },
      { id: 8, title: '第8话 - 最终之战', updatedAt: '2026-05-26' },
    ],
  },
  {
    slug: 'mishi-zhi-cheng',
    title: '迷失之城',
    author: '郑宇成',
    cover: 'https://readdy.ai/api/search-image?query=A%20mysterious%20thriller%20Korean%20webtoon%20cover%20featuring%20a%20foggy%20abandoned%20city%20with%20silhouetted%20figures%2C%20suspense%20genre%2C%20dark%20atmospheric%20mood%2C%20clean%20simple%20neutral%20cream%20background%2C%20eerie%20vibe%2C%20digital%20illustration%20with%20muted%20colors&width=600&height=800&seq=manga-cover-04&orientation=portrait',
    category: '悬疑',
    status: '连载中',
    rating: 9.3,
    views: 1560000,
    description: '一群互不相识的人在某天醒来，发现自己身处一座诡异的空城之中。城中没有其他人，却处处透露着有人居住的痕迹。随着探索深入，他们发现了这座城市的可怕秘密——每个人都被某种力量困在这里，而出口只有一个。',
    tags: ['悬疑', '生存', '群像', '惊悚'],
    updatedAt: '2026-08-03',
    chapters: [
      { id: 1, title: '第1话 - 醒来', updatedAt: '2026-06-01' },
      { id: 2, title: '第2话 - 空城', updatedAt: '2026-06-03' },
      { id: 3, title: '第3话 - 痕迹', updatedAt: '2026-06-06' },
      { id: 4, title: '第4话 - 规则', updatedAt: '2026-06-10' },
      { id: 5, title: '第5话 - 第一个死者', updatedAt: '2026-06-14' },
      { id: 6, title: '第6话 - 怀疑', updatedAt: '2026-06-18' },
      { id: 7, title: '第7话 - 线索', updatedAt: '2026-06-22' },
      { id: 8, title: '第8话 - 地下', updatedAt: '2026-06-26' },
    ],
  },
  {
    slug: 'chongsheng-wei-wang',
    title: '重生为王',
    author: '韩志勋',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20webtoon%20cover%20of%20reincarnation%20fantasy%20genre%2C%20a%20powerful%20king%20standing%20on%20castle%20battlements%20looking%20over%20a%20kingdom%2C%20regal%20and%20majestic%20atmosphere%2C%20warm%20golden%20light%2C%20clean%20cream%20background%2C%20digital%20illustration%20with%20rich%20detail&width=600&height=800&seq=manga-cover-05&orientation=portrait',
    category: '奇幻',
    status: '连载中',
    rating: 9.4,
    views: 2130000,
    description: '一代枭雄在登基之日被最信任的部下背叛而死，却意外重生回到二十年前的少年时代。带着前世记忆与经验，他决定改写命运，不仅要夺回属于自己的一切，更要守护那些在前世被辜负的人们。',
    tags: ['重生', '复仇', '权谋', '成长'],
    updatedAt: '2026-08-05',
    chapters: [
      { id: 1, title: '第1话 - 背叛与重生', updatedAt: '2026-05-20' },
      { id: 2, title: '第2话 - 少年归来', updatedAt: '2026-05-22' },
      { id: 3, title: '第3话 - 第一步棋', updatedAt: '2026-05-25' },
      { id: 4, title: '第4话 - 隐藏实力', updatedAt: '2026-05-29' },
      { id: 5, title: '第5话 - 旧敌现身', updatedAt: '2026-06-02' },
      { id: 6, title: '第6话 - 收服人心', updatedAt: '2026-06-06' },
      { id: 7, title: '第7话 - 比武大会', updatedAt: '2026-06-10' },
      { id: 8, title: '第8话 - 一战成名', updatedAt: '2026-06-15' },
      { id: 9, title: '第9话 - 暗棋布局', updatedAt: '2026-06-20' },
    ],
  },
  {
    slug: 'tianmi-quanji',
    title: '甜蜜圈纪',
    author: '尹美娜',
    cover: 'https://readdy.ai/api/search-image?query=A%20sweet%20romance%20Korean%20webtoon%20cover%2C%20young%20couple%20sharing%20dessert%20in%20a%20cozy%20cafe%2C%20warm%20pastel%20pink%20and%20cream%20tones%2C%20heartwarming%20love%20story%20vibe%2C%20clean%20simple%20cream%20background%2C%20delicate%20and%20soft%20digital%20illustration&width=600&height=800&seq=manga-cover-06&orientation=portrait',
    category: '恋爱',
    status: '已完结',
    rating: 9.1,
    views: 1670000,
    description: '糕点师韩智雅和美食评论家朴泰俊因一块蛋糕结缘，从此展开了一段甜到发腻的恋爱故事。两人在美食与爱情中互相治愈，一起面对生活中的酸甜苦辣。每一话都像一道精致的甜点，让人回味无穷。',
    tags: ['恋爱', '美食', '治愈', '日常'],
    updatedAt: '2026-07-15',
    chapters: [
      { id: 1, title: '第1话 - 遇见你', updatedAt: '2026-04-01' },
      { id: 2, title: '第2话 - 草莓蛋糕', updatedAt: '2026-04-03' },
      { id: 3, title: '第3话 - 误会', updatedAt: '2026-04-07' },
      { id: 4, title: '第4话 - 心跳加速', updatedAt: '2026-04-12' },
      { id: 5, title: '第5话 - 第一次约会', updatedAt: '2026-04-18' },
      { id: 6, title: '第6话 - 甜蜜告白', updatedAt: '2026-04-25' },
    ],
  },
  {
    slug: 'tianming-zhi-zi',
    title: '天命之子',
    author: '崔东旭',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20martial%20arts%20webtoon%20cover%2C%20young%20warrior%20with%20glowing%20martial%20energy%20in%20ancient%20Korean%20setting%2C%20epic%20wuxia%20style%2C%20dramatic%20golden%20light%20effects%2C%20clean%20cream%20background%2C%20powerful%20and%20heroic%20digital%20illustration&width=600&height=800&seq=manga-cover-07&orientation=portrait',
    category: '热血',
    status: '连载中',
    rating: 9.6,
    views: 3120000,
    description: '在武者为尊的世界里，出身卑微的少年江辰被认定为天命之子，拥有传说中的九阳圣体。从此他踏上武道巅峰之路，一路披荆斩棘、收服强敌、结识挚友。燃到爆炸的战斗场面与细腻的人物情感交织，堪称热血漫画的巅峰之作。',
    tags: ['武侠', '热血', '成长', '战斗'],
    updatedAt: '2026-08-04',
    chapters: [
      { id: 1, title: '第1话 - 天命觉醒', updatedAt: '2026-05-10' },
      { id: 2, title: '第2话 - 初入宗门', updatedAt: '2026-05-13' },
      { id: 3, title: '第3话 - 九阳圣体', updatedAt: '2026-05-17' },
      { id: 4, title: '第4话 - 内门考核', updatedAt: '2026-05-22' },
      { id: 5, title: '第5话 - 越级挑战', updatedAt: '2026-05-27' },
      { id: 6, title: '第6话 - 秘境试炼', updatedAt: '2026-06-01' },
      { id: 7, title: '第7话 - 天骄之战', updatedAt: '2026-06-06' },
      { id: 8, title: '第8话 - 恩怨情仇', updatedAt: '2026-06-12' },
      { id: 9, title: '第9话 - 远古遗迹', updatedAt: '2026-06-18' },
      { id: 10, title: '第10话 - 破境之战', updatedAt: '2026-06-25' },
      { id: 11, title: '第11话 - 决战前夕', updatedAt: '2026-07-02' },
      { id: 12, title: '第12话 - 巅峰对决', updatedAt: '2026-07-10' },
    ],
  },
  {
    slug: 'xueyue-zhi-hua',
    title: '血月之花',
    author: '姜美妍',
    cover: 'https://readdy.ai/api/search-image?query=A%20dark%20fantasy%20horror%20Korean%20webtoon%20cover%2C%20blood%20red%20moon%20over%20a%20field%20of%20mysterious%20flowers%2C%20gothic%20atmosphere%2C%20beautiful%20but%20eerie%2C%20clean%20dark%20cream%20background%2C%20detailed%20and%20atmospheric%20digital%20illustration&width=600&height=800&seq=manga-cover-08&orientation=portrait',
    category: '悬疑',
    status: '连载中',
    rating: 9.0,
    views: 1340000,
    description: '每个血月之夜，小镇上就会有一朵神秘的花绽放，而随之而来的是一桩离奇的死亡事件。侦探柳真雅奉命调查这系列案件，却发现自己似乎与这些血月之花有着不为人知的联系……扣人心弦的悬疑推理故事。',
    tags: ['悬疑', '推理', '超自然', '恐怖'],
    updatedAt: '2026-08-02',
    chapters: [
      { id: 1, title: '第1话 - 血月之夜', updatedAt: '2026-06-01' },
      { id: 2, title: '第2话 - 第一朵花', updatedAt: '2026-06-04' },
      { id: 3, title: '第3话 - 侦探登场', updatedAt: '2026-06-08' },
      { id: 4, title: '第4话 - 第二个牺牲者', updatedAt: '2026-06-13' },
      { id: 5, title: '第5话 - 共同点', updatedAt: '2026-06-18' },
      { id: 6, title: '第6话 - 花语之谜', updatedAt: '2026-06-24' },
    ],
  },
  {
    slug: 'yijie-zhi-men',
    title: '异界之门',
    author: '宋贤宇',
    cover: 'https://readdy.ai/api/search-image?query=A%20fantasy%20adventure%20Korean%20webtoon%20cover%2C%20a%20glowing%20portal%20gate%20to%20another%20world%2C%20adventurers%20stepping%20through%2C%20epic%20fantasy%20setting%2C%20warm%20golden%20and%20green%20tones%2C%20clean%20cream%20background%2C%20adventurous%20digital%20illustration&width=600&height=800&seq=manga-cover-09&orientation=portrait',
    category: '奇幻',
    status: '已完结',
    rating: 9.2,
    views: 1980000,
    description: '某天世界各地突然出现了连接异世界的传送门，冒险者这一职业应运而生。主角团队作为顶尖冒险者，深入各个异界探索未知，与异界生物战斗、发现古代文明遗迹、揭开传送门背后的真相。宏大的世界观与精彩的冒险故事。',
    tags: ['冒险', '异世界', '团队', '探索'],
    updatedAt: '2026-06-30',
    chapters: [
      { id: 1, title: '第1话 - 门开了', updatedAt: '2026-03-01' },
      { id: 2, title: '第2话 - 冒险者', updatedAt: '2026-03-05' },
      { id: 3, title: '第3话 - 初次探索', updatedAt: '2026-03-10' },
      { id: 4, title: '第4话 - 精灵森林', updatedAt: '2026-03-16' },
      { id: 5, title: '第5话 - 古代遗迹', updatedAt: '2026-03-23' },
      { id: 6, title: '第6话 - 巨龙苏醒', updatedAt: '2026-03-30' },
      { id: 7, title: '第7话 - 世界真相', updatedAt: '2026-04-08' },
      { id: 8, title: '第8话 - 最终之门', updatedAt: '2026-04-18' },
      { id: 9, title: '第9话 - 归途', updatedAt: '2026-04-30' },
    ],
  },
  {
    slug: 'xiaoyuan-mishi',
    title: '校园秘史',
    author: '张瑞希',
    cover: 'https://readdy.ai/api/search-image?query=A%20school%20mystery%20Korean%20webtoon%20cover%2C%20students%20in%20school%20uniforms%20in%20a%20mysterious%20empty%20classroom%2C%20suspenseful%20atmosphere%2C%20light%20cream%20and%20soft%20blue%20tones%2C%20clean%20simple%20background%2C%20intriguing%20digital%20illustration&width=600&height=800&seq=manga-cover-10&orientation=portrait',
    category: '悬疑',
    status: '连载中',
    rating: 8.9,
    views: 1120000,
    description: '明星高中里流传着七个校园怪谈，每个怪谈背后都隐藏着一段不为人知的往事。新闻社的四名学生决定调查这些怪谈的真相，却意外揭开了一连串令人震惊的校园黑幕。青春悬疑与校园推理的完美结合。',
    tags: ['校园', '悬疑', '推理', '青春'],
    updatedAt: '2026-08-01',
    chapters: [
      { id: 1, title: '第1话 - 七个怪谈', updatedAt: '2026-06-15' },
      { id: 2, title: '第2话 - 音乐室的钢琴', updatedAt: '2026-06-18' },
      { id: 3, title: '第3话 - 体育馆的脚步声', updatedAt: '2026-06-22' },
      { id: 4, title: '第4话 - 图书馆的秘密', updatedAt: '2026-06-27' },
      { id: 5, title: '第5话 - 天台上的影子', updatedAt: '2026-07-02' },
    ],
  },
  {
    slug: 'shen-jian-chuan-shuo',
    title: '神剑传说',
    author: '姜东元',
    cover: 'https://readdy.ai/api/search-image?query=A%20legendary%20sword%20fantasy%20Korean%20webtoon%20cover%2C%20magical%20sword%20embedded%20in%20stone%20with%20golden%20light%20radiating%2C%20medieval%20fantasy%20setting%2C%20heroic%20and%20epic%20mood%2C%20clean%20cream%20background%2C%20majestic%20digital%20illustration&width=600&height=800&seq=manga-cover-11&orientation=portrait',
    category: '热血',
    status: '连载中',
    rating: 9.3,
    views: 2450000,
    description: '传说中封印着上古神力的七把神剑散落在大陆各处。少年剑士叶凌云踏上寻找神剑的旅程，在途中遇到了志同道合的伙伴，也遭遇了同样觊觎神剑之力的邪恶势力。剑与魔法的史诗冒险，热血与羁绊交织的传奇故事。',
    tags: ['剑与魔法', '冒险', '热血', '伙伴'],
    updatedAt: '2026-08-03',
    chapters: [
      { id: 1, title: '第1话 - 神剑传说', updatedAt: '2026-06-01' },
      { id: 2, title: '第2话 - 出发', updatedAt: '2026-06-05' },
      { id: 3, title: '第3话 - 第一把剑', updatedAt: '2026-06-10' },
      { id: 4, title: '第4话 - 沙漠之城', updatedAt: '2026-06-16' },
      { id: 5, title: '第5话 - 炎之试炼', updatedAt: '2026-06-22' },
      { id: 6, title: '第6话 - 新的同伴', updatedAt: '2026-06-28' },
      { id: 7, title: '第7话 - 暗影来袭', updatedAt: '2026-07-05' },
    ],
  },
  {
    slug: 'aiqing-youxizhi',
    title: '爱情游戏志',
    author: '金荷娜',
    cover: 'https://readdy.ai/api/search-image?query=A%20romantic%20comedy%20Korean%20webtoon%20cover%2C%20two%20young%20adults%20in%20a%20game%20company%20office%2C%20playful%20and%20sweet%20vibe%2C%20soft%20pastel%20cream%20and%20coral%20tones%2C%20clean%20simple%20background%2C%20charming%20digital%20illustration&width=600&height=800&seq=manga-cover-12&orientation=portrait',
    category: '恋爱',
    status: '连载中',
    rating: 8.8,
    views: 980000,
    description: '游戏公司的新人策划师林小甜，被分配到一个全是男同事的项目组。在开发恋爱模拟游戏的过程中，她与高冷程序员组长之间产生了微妙的化学反应。职场恋爱喜剧，既有甜蜜互动，又有游戏开发的趣味日常。',
    tags: ['职场', '恋爱', '喜剧', '游戏'],
    updatedAt: '2026-08-04',
    chapters: [
      { id: 1, title: '第1话 - 入职第一天', updatedAt: '2026-07-01' },
      { id: 2, title: '第2话 - 全男项目组', updatedAt: '2026-07-04' },
      { id: 3, title: '第3话 - 第一次交锋', updatedAt: '2026-07-08' },
      { id: 4, title: '第4话 - 加班之夜', updatedAt: '2026-07-13' },
      { id: 5, title: '第5话 - 心动信号', updatedAt: '2026-07-19' },
    ],
  },
];

export const categories = ['全部', '恋爱', '热血', '奇幻', '悬疑'];

export function getMangaBySlug(slug: string): MangaItem | undefined {
  return mangaList.find((manga) => manga.slug === slug);
}

export function getMangaByCategory(category: string): MangaItem[] {
  if (category === '全部') return mangaList;
  return mangaList.filter((manga) => manga.category === category);
}

export function getFeaturedManga(): MangaItem[] {
  return mangaList.filter((manga) => manga.rating >= 9.3).slice(0, 6);
}

export function getPopularManga(): MangaItem[] {
  return [...mangaList].sort((a, b) => b.views - a.views).slice(0, 8);
}

export function getNewArrivalManga(): MangaItem[] {
  return [...mangaList].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, 8);
}

export default mangaList;